import { render, staticRenderFns } from "./HeadlineWithTextAndYoutubeVideo.vue?vue&type=template&id=59a2211e&"
import script from "./HeadlineWithTextAndYoutubeVideo.vue?vue&type=script&lang=js&"
export * from "./HeadlineWithTextAndYoutubeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})
